import React, { useCallback } from "react";
import styles from "../../../styles/pages/user/qcagentdashboard/qcagent-dasboard.module.scss";
import { Box, Stack } from "@mui/system";
import {
  Button,
  Dialog,
  List,
  ListItem,
  Menu,
  MenuItem,
  Slide,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import QcModalVideo from "../../../ui/Icons/QcModalVideo";
import QcagentDashboardFilter from "../../../components/QcagentDashboardFilter/QcagentDashboardFilter";
import QcagentPendingTable from "../../../components/QcagentPendingTable/QcagentPendingTable";
import QcModalClose from "../../../ui/Icons/QcModalClose";

import { FetchQCVideos } from "../../../api/functions/video.api";
import { getStartEndDateTwo } from "../../../lib/functions/utils.lib";
import { useState } from "react";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useQuery } from "react-query";
import { useEffect } from "react";
import {
  setUserId,
  setMonth,
  setYear,
  setSubmitPlace,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
} from "../../../redux-toolkit/slices/qc/qc.dashboard.pending.titling.slice";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import { useAppSelector } from "../../../hooks/useAppSelector";

const QcTitlingModal = ({ open, handleClose }) => {
  const [page, setPage] = useState(1);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const dispatch = useAppDispatch();
  //   const [pending_titling, setPendingTitling] = useState(true);
  //   const [revision_request, setRevisionRequest] = useState(true);

  const [pendingRev, setPendingRev] = useState(false);
  // console.warn("pendingRev", pendingRev);

  const togglePending = useCallback(() => {
    setPendingRev((pre) => !pre);
  }, []);

  const { month, year, from, to } = useAppSelector(
    (s) => s.qcDashboardPendingTitlingSlice
  );

  const {
    error,
    data,
    isLoading,
    refetch: refetchAgain,
  } = useQuery(
    ["qc_dashboard_titling"],
    async () =>
      FetchQCVideos({
        page,
        pending_titling: pendingRev ? null : true,
        revision_request: pendingRev ? true : null,
        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
      }),
    {
      enabled: open,
    }
  );

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const handlePageChange = (p) => {
    setPage(p);
    handleTriggreFetch();
  };
  useEffect(() => {
    if (fetchTrigger && open) {
      refetchAgain();
    }
  }, [fetchTrigger, open, pendingRev]);
  // console.warn("data--------------", data?.data);

  const filterRefetch = () => {
    handleTriggreFetch();
    setOpenFilterModal(false);
    setPage(1);
  };

  const filtersReset = () => {
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setSubmitPlace(null));
    dispatch(setHasNote(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setHasMessage(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    setPage(1);
    handleTriggreFetch();
  };

  // const [filterActive, setFilterActive] = useState(false);
  // useEffect(() => {
  //   if (
  //     user_id ||
  //     month ||
  //     year ||
  //     submit_place ||
  //     has_note ||
  //     unreachable_submitter ||
  //     hasMessage ||
  //     people_appearing ||
  //     person_who_filmed ||
  //     submit_other_website ||
  //     aggrement_with_another_company
  //   ) {
  //     setFilterActive(true);
  //   } else {
  //     setFilterActive(false);
  //   }
  // }, [
  //   user_id,
  //   month,
  //   year,
  //   submit_place,
  //   has_note,
  //   unreachable_submitter,
  //   hasMessage,
  //   people_appearing,
  //   person_who_filmed,
  //   submit_other_website,
  //   aggrement_with_another_company,
  // ]);

  return (
    <>
      <ApiLoader loading={isLoading} />
      <Dialog fullScreen open={open} onClose={handleClose}>
        <Box className={styles.qcModal_wrapper}>
          <Button className={styles.modal_close} onClick={handleClose}>
            <QcModalClose />
          </Button>
          <Box className={styles.qcModal_heading}>
            <Typography variant="h2">
              <QcModalVideo />
              <Typography variant="caption">Videos Pending Titling</Typography>
            </Typography>
          </Box>
          <Box className={styles.qcModal_wrapper_inner}>
            <QcagentDashboardFilter
              handleTriggreFetch={handleTriggreFetch}
              filterActive={false}
              handleClearFilterModal={filtersReset}
              filtersReset={filtersReset}
              filterRefetch={filterRefetch}
              openFilterModal={openFilterModal}
              setOpenFilterModal={setOpenFilterModal}
              datas={data?.data}
              togglePending={togglePending}
              pendingRev={pendingRev}
              hideFilter
            />
            <QcagentPendingTable
              datas={data?.data}
              page={page}
              pendingTitle="Titling"
              handlePageChange={handlePageChange}
              filterActive={false}
              handleTriggreFetch={handleTriggreFetch}
              handleClearFilterModal={filtersReset}
              filtersReset={filtersReset}
              loading={isLoading}
            />
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default QcTitlingModal;
